// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.disabled-section {
  opacity: 0.6;
  pointer-events: none; /* Prevents any interaction */
}

/* .disabled-button {
   
    pointer-events: none;
    cursor: not-allowed;
  } */

.cleaning-link-main-wrap {
  margin-top: 20px;
  padding-bottom: 100px !important;
}

.employee-booking-head-wrap h3 {
  font-size: 18px;
  color: #1a1919;
  font-weight: bold;
  margin: 0px;
}

.employee-booking-head-wrap p {
  font-size: 14px;
  color: #1a1919;
  font-weight: 400;
  margin: 0px;
}

.empoyee-retail-content p {
  font-size: 14px;
  color: #00a19b;
  font-weight: 600;
  margin: 0px;
  margin-top: 20px;
}

.empoyee-squrefeet-content {
  margin-top: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.empoyee-squrefeet-content p {
  font-size: 14px;
  color: #1a1919;
  font-weight: 400;
  margin: 0px;
}

.empoyee-squrefeet-content span {
  font-size: 14px;
  color: #1a1919;
  font-weight: 500;
  margin: 0px;
}

.empoyee-item-detail-wrap h4 {
  font-size: 16px;
  color: #1a1919;
  font-weight: 600;
  margin: 0px;
  margin-top: 22px;
  margin-bottom: 16px;
}

span.extra-item-size-text {
  font-weight: 500;
  color: #1a1919;
  margin-left: 3px;
  margin-right: 4px;
}

.employee-cart-item-right {
  text-align: right;
}

.employee-cart-item-right .booking-item-price-wrap p {
  font-size: 14px;
  color: #1a1919;
  font-weight: 600;
  margin: 0px;
  min-width: 80px;
}

.employee-address-repeat {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 12px;
}

.employee-address-left p {
  font-size: 14px;
  color: #1a1919;
  font-weight: 400;
  margin: 0px;
  min-width: 100px;
}

.employee-address-right p {
  font-size: 14px;
  color: #626262;
  font-weight: 400;
  margin: 0px;
  text-align: right;
}

.employee-address-right {
  display: flex;
}

p.employee-schedule-time {
  border-left: 1px solid #ccc;
  padding-left: 5px;
}

p.employee-schedule-date {
  padding-right: 5px;
}

.employee-address-detail-wrap {
  border-top: 1px dashed #e1e1e1;
  padding-top: 20px;
  margin-top: 20px;
  padding-bottom: 4px;
}

.empolyee-arrived-swipper-btn {
  position: sticky;
  bottom: 80px;
  width: 100%;
  background: #fff;
  border-top: 1px solid #e1e1e1;
  padding: 20px 20px 20px 20px;
}

.empolyee-otp-swipper-btn {
  position: fixed;
  bottom: 80px;
  width: 100%;
  background: #fff;
  padding: 20px 20px 20px 20px;
}

.cleaning-link-main-wrapper {
  position: relative;
}

/******* Enter Otp Screen for Employee ****/
.employee-otp-main-wrapper {
  margin-top: 32px;
}

.employee-otp-main-wrap h3 {
  font-size: 18px;
  color: #1a1919;
  font-weight: bold;
  margin: 0px;
}

.otp-input-main-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 50vh;
  text-align: left;
}

.otp-input-main-wrapper p {
  font-size: 14px;
  color: #1a1919;
  font-weight: 400;
  margin-left: 10px;
  margin-bottom: 10px;
}

.pin-code.otp-input-main-wrap {
  display: flex;
  gap: 8px;
  justify-content: center;
}

.pin-code.otp-input-main-wrap input {
  text-align: center;
  width: 53px;
  height: 53px;
  font-size: 18px;
  font-weight: 600;
  background-color: #f3f3f3;
  border-radius: 13px;
  color: #1a1919;
  outline: none;
  border: none;
  padding: 0px;
}

.confirm-and-cancel-wrap {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}

.confirm-and-cancel-wrap img.cancel-btn-icon {
  width: 70px;
}

.cleaning-order-complete-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 250px);
}

.employe-order-complete-img {
  text-align: center;
}

.employe-order-complete-img img {
  width: 175px;
}

.employe-order-complete-img h3 {
  font-size: 22px;
  color: #00a19b;
  font-weight: 700;
  margin: 0px;
  margin-top: -20px;
}

.employee-order-cancel-img h3 {
  margin-top: 10px;
}

.complete-order-bookingid {
  text-align: center;
  margin-top: 30px;
}

.complete-order-bookingid h3 {
  font-size: 18px;
  color: #1a1919;
  font-weight: 700;
  margin: 0px;
}

.complete-order-bookingid p {
  font-size: 14px;
  color: #1a1919;
  font-weight: 400;
  margin: 0px;
  padding-top: 6px;
}

.employee-change-req-content p {
  font-size: 16px;
  text-align: center;
  color: #1a1919;
  font-weight: 600;
  margin-top: 50px;
  margin-bottom: 0px;
}

.not-availible-form-desktop {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: calc(100vh - 100px);
}

.not-availible-form-desktop h3 {
  text-align: center;
  font-size: 32px;
  font-weight: 600;
  color: #1a1919;
  margin: 0px;
}

.not-availible-form-desktop p {
  text-align: center;
  font-size: 20px;
  width: 300px;
  font-weight: 400;
  color: #1a1919;
  margin: 0px;
  padding-top: 15px;
}

.change-order-proceed-btn {
  width: 300px;
  margin-top: 50px;
}

.change-order-proceed-btn button {
  height: 49px;
}



@media (min-width: 1200px) {
  .employee-change-req-content {
    width: 50%;
  }
}

@media (min-width: 1600px) {
  .employee-change-req-content {
    width: 40%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/dashboard/changeOrder/changeOrder.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,oBAAoB,EAAE,6BAA6B;AACrD;;AAEA;;;;KAIK;;AAEL;EACE,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;AACpB;;AAEA,2CAA2C;AAC3C;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;;;AAIA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF","sourcesContent":[".disabled-section {\n  opacity: 0.6;\n  pointer-events: none; /* Prevents any interaction */\n}\n\n/* .disabled-button {\n   \n    pointer-events: none;\n    cursor: not-allowed;\n  } */\n\n.cleaning-link-main-wrap {\n  margin-top: 20px;\n  padding-bottom: 100px !important;\n}\n\n.employee-booking-head-wrap h3 {\n  font-size: 18px;\n  color: #1a1919;\n  font-weight: bold;\n  margin: 0px;\n}\n\n.employee-booking-head-wrap p {\n  font-size: 14px;\n  color: #1a1919;\n  font-weight: 400;\n  margin: 0px;\n}\n\n.empoyee-retail-content p {\n  font-size: 14px;\n  color: #00a19b;\n  font-weight: 600;\n  margin: 0px;\n  margin-top: 20px;\n}\n\n.empoyee-squrefeet-content {\n  margin-top: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.empoyee-squrefeet-content p {\n  font-size: 14px;\n  color: #1a1919;\n  font-weight: 400;\n  margin: 0px;\n}\n\n.empoyee-squrefeet-content span {\n  font-size: 14px;\n  color: #1a1919;\n  font-weight: 500;\n  margin: 0px;\n}\n\n.empoyee-item-detail-wrap h4 {\n  font-size: 16px;\n  color: #1a1919;\n  font-weight: 600;\n  margin: 0px;\n  margin-top: 22px;\n  margin-bottom: 16px;\n}\n\nspan.extra-item-size-text {\n  font-weight: 500;\n  color: #1a1919;\n  margin-left: 3px;\n  margin-right: 4px;\n}\n\n.employee-cart-item-right {\n  text-align: right;\n}\n\n.employee-cart-item-right .booking-item-price-wrap p {\n  font-size: 14px;\n  color: #1a1919;\n  font-weight: 600;\n  margin: 0px;\n  min-width: 80px;\n}\n\n.employee-address-repeat {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  margin-bottom: 12px;\n}\n\n.employee-address-left p {\n  font-size: 14px;\n  color: #1a1919;\n  font-weight: 400;\n  margin: 0px;\n  min-width: 100px;\n}\n\n.employee-address-right p {\n  font-size: 14px;\n  color: #626262;\n  font-weight: 400;\n  margin: 0px;\n  text-align: right;\n}\n\n.employee-address-right {\n  display: flex;\n}\n\np.employee-schedule-time {\n  border-left: 1px solid #ccc;\n  padding-left: 5px;\n}\n\np.employee-schedule-date {\n  padding-right: 5px;\n}\n\n.employee-address-detail-wrap {\n  border-top: 1px dashed #e1e1e1;\n  padding-top: 20px;\n  margin-top: 20px;\n  padding-bottom: 4px;\n}\n\n.empolyee-arrived-swipper-btn {\n  position: sticky;\n  bottom: 80px;\n  width: 100%;\n  background: #fff;\n  border-top: 1px solid #e1e1e1;\n  padding: 20px 20px 20px 20px;\n}\n\n.empolyee-otp-swipper-btn {\n  position: fixed;\n  bottom: 80px;\n  width: 100%;\n  background: #fff;\n  padding: 20px 20px 20px 20px;\n}\n\n.cleaning-link-main-wrapper {\n  position: relative;\n}\n\n/******* Enter Otp Screen for Employee ****/\n.employee-otp-main-wrapper {\n  margin-top: 32px;\n}\n\n.employee-otp-main-wrap h3 {\n  font-size: 18px;\n  color: #1a1919;\n  font-weight: bold;\n  margin: 0px;\n}\n\n.otp-input-main-wrapper {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  height: 50vh;\n  text-align: left;\n}\n\n.otp-input-main-wrapper p {\n  font-size: 14px;\n  color: #1a1919;\n  font-weight: 400;\n  margin-left: 10px;\n  margin-bottom: 10px;\n}\n\n.pin-code.otp-input-main-wrap {\n  display: flex;\n  gap: 8px;\n  justify-content: center;\n}\n\n.pin-code.otp-input-main-wrap input {\n  text-align: center;\n  width: 53px;\n  height: 53px;\n  font-size: 18px;\n  font-weight: 600;\n  background-color: #f3f3f3;\n  border-radius: 13px;\n  color: #1a1919;\n  outline: none;\n  border: none;\n  padding: 0px;\n}\n\n.confirm-and-cancel-wrap {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 12px;\n}\n\n.confirm-and-cancel-wrap img.cancel-btn-icon {\n  width: 70px;\n}\n\n.cleaning-order-complete-wrap {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: calc(100vh - 250px);\n}\n\n.employe-order-complete-img {\n  text-align: center;\n}\n\n.employe-order-complete-img img {\n  width: 175px;\n}\n\n.employe-order-complete-img h3 {\n  font-size: 22px;\n  color: #00a19b;\n  font-weight: 700;\n  margin: 0px;\n  margin-top: -20px;\n}\n\n.employee-order-cancel-img h3 {\n  margin-top: 10px;\n}\n\n.complete-order-bookingid {\n  text-align: center;\n  margin-top: 30px;\n}\n\n.complete-order-bookingid h3 {\n  font-size: 18px;\n  color: #1a1919;\n  font-weight: 700;\n  margin: 0px;\n}\n\n.complete-order-bookingid p {\n  font-size: 14px;\n  color: #1a1919;\n  font-weight: 400;\n  margin: 0px;\n  padding-top: 6px;\n}\n\n.employee-change-req-content p {\n  font-size: 16px;\n  text-align: center;\n  color: #1a1919;\n  font-weight: 600;\n  margin-top: 50px;\n  margin-bottom: 0px;\n}\n\n.not-availible-form-desktop {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  height: calc(100vh - 100px);\n}\n\n.not-availible-form-desktop h3 {\n  text-align: center;\n  font-size: 32px;\n  font-weight: 600;\n  color: #1a1919;\n  margin: 0px;\n}\n\n.not-availible-form-desktop p {\n  text-align: center;\n  font-size: 20px;\n  width: 300px;\n  font-weight: 400;\n  color: #1a1919;\n  margin: 0px;\n  padding-top: 15px;\n}\n\n.change-order-proceed-btn {\n  width: 300px;\n  margin-top: 50px;\n}\n\n.change-order-proceed-btn button {\n  height: 49px;\n}\n\n\n\n@media (min-width: 1200px) {\n  .employee-change-req-content {\n    width: 50%;\n  }\n}\n\n@media (min-width: 1600px) {\n  .employee-change-req-content {\n    width: 40%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
